.ux-iws-stateful-filter-search {
    display: block;
    min-width: 100%;

    @media (min-width: 768px) {
        min-width: 370px;
    }

    form {
        display: flex;
        flex-direction: row;
        margin: 0;
    }

    ux-input-field {
        width: 100%;
    }
}
